import AxiosInstance from "./apiClient";

// Delete address
export const deleteAddressApi = async (id) => {
  const url = `address/${id}`;
  try {
    const res = await AxiosInstance.delete(url);
    return res?.data;
  } catch (error) {
    console.log("Error deleting address:", error);
    throw error;
  }
};
